const types = {
	SCREEN_RESIZE: 'SCREEN_RESIZE',
	SCROLL: 'SCROLL',
	MOBILE_MENU_TOGGLE: 'MOBILE_MENU_TOGGLE',
	MOBILE_MENU_OPEN: 'MOBILE_MENU_OPEN',
	MOBILE_MENU_CLOSE: 'MOBILE_MENU_CLOSE'
};

function calcSizes() {
	let sizes = {
			w: window.innerWidth,
			h: window.innerHeight,
			mq: 'xss',
			
			title: {},
			home: {slide:{}}
	}
	let o = 'landscape'
	sizes.o = 'l'
	sizes.ratio = sizes.w / sizes.h
	if (sizes.w<sizes.h) {
		o = 'portrait'
		sizes.o = 'p'
		if (sizes.ratio>0.65) {
			sizes.ratiobk = '4x3'
		} else {
			sizes.ratiobk = '16x9'
		}
	} else {
		if (sizes.ratio<1.5) {
			sizes.ratiobk = '4x3'
		} else {
			sizes.ratiobk = '16x9'
		}
	}

	if (sizes.w>400) {
		sizes.mq = 'xs';
	}
	
	if (sizes.w>600) {
		sizes.mq = 'sm';
	}
	
	if (sizes.w>900) {
		sizes.mq = 'md';
	}
	
	if (sizes.w>1200) {
		sizes.mq = 'lg';
	}
	document.documentElement.style.setProperty('--aspect', sizes.w/sizes.h)
	document.body.className = sizes.mq + ' ' + o
	
	sizes.title.lg = sizes.w/15
	sizes.title.md = sizes.w/20
	sizes.title.sm = sizes.w/25

	sizes.section = sizes.w/50

	//sizes.home.slide.fontSize = (sizes.o==='l'? sizes.w/70 : sizes.w/25)+ 'px'
	sizes.home.slide.fontSize = '17px'

	switch(sizes.mq) {
		case 'lg':
			break
		case 'md':
			sizes.home.slide.fontSize = '16px'
			break
		case 'sm':
			sizes.home.slide.fontSize = '14px'
			break
		case 'xs':
			sizes.home.slide.fontSize = '12px'
			break
		default:
			sizes.home.slide.fontSize = '10px'
			break
	}
	sizes.screen = {
		mq: sizes.mq,
		o: sizes.o,
		r: sizes.ratiobk
	}
	//console.log(sizes)
	return sizes
}
function scrollY() {
	//console.log('scroll')
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
    let ret = supportPageOffset ? window.pageYOffset : isCSS1Compat ?
        document.documentElement.scrollTop : document.body.scrollTop;
    if (ret===0) {
    	if(document.body.classList.contains('not-top')) {
    		document.body.classList.remove('not-top')
    	}
    } else {
    	if(!document.body.classList.contains('not-top')) {
    		document.body.classList.add('not-top')
    	}
    }
    return ret;
}

const initialState = {
	...calcSizes(),
	scroll: scrollY(),
	mobileMenu: false
};
export default function screenReducer(state = initialState, action) {
   	//console.log(action);
	switch(action.type) {
        case types.SCREEN_RESIZE:
        	return Object.assign({}, state, calcSizes())
		case types.MOBILE_MENU_TOGGLE:
        	return Object.assign({}, state, {mobileMenu: !state.mobileMenu})
		case types.MOBILE_MENU_OPEN:
        	return Object.assign({}, state, {mobileMenu: true})
		case types.MOBILE_MENU_CLOSE:
        	return Object.assign({}, state, {mobileMenu: false})
		case types.SCROLL:
        	return Object.assign({}, state, {scroll: scrollY()})
		default:
			return state;
	}
}

//export const actions = {
const screenResize = () => ({ type: types.SCREEN_RESIZE })
const mobileMenuToggle = () => ({ type: types.MOBILE_MENU_TOGGLE })
const mobileMenuOpen = () => ({ type: types.MOBILE_MENU_OPEN })
const mobileMenuClose = () => ({ type: types.MOBILE_MENU_CLOSE })
const scroll = () => ({ type: types.SCROLL })
//};
/*
export function closeMobileMenu() {
	return (dispatch, getState) => {
		if (!getState().screen.mobileMenu) return
		return dispatch(actions.mobileMenuClose())
	}
}
*/
export {screenResize, mobileMenuToggle, mobileMenuOpen, mobileMenuClose, scroll}


// WEBPACK FOOTER //
// ./src/fm/reducers/screen.js